import React from 'react';
import PeptideCalculatorTemplate from '../components/PeptideCalculatorTemplate';
import { PEPTIDE_DATA } from '../data/peptideCalculatorData';

const CJC1295Calculator = () => {
  return <PeptideCalculatorTemplate peptideData={PEPTIDE_DATA.cjc1295} />;
};

export default CJC1295Calculator;
